import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	fetchError: {
		id: 'software-reports.velocity-report.error-empty-state.fetch-error',
		defaultMessage: 'There was an error while fetching your report.',
		description: 'Message shown when the request to load the velocity report fails',
	},
});

export default messages;
